<template>
  <div class="w-100  p-map-salon-map-main">
        <l-map
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate($event)"
        @click="addMarker"
      >
        <l-tile-layer
          :url="url"
        />
        <l-marker

        :lat-lng="withPopup"
        :icon="icon"
        >
        </l-marker>

    </l-map>
  </div>
</template>

<script>
import { latLng,icon,L,map  } from "leaflet";


export default {
  name: "mapSalon",
  components: {
  },

  props: {
    formData   : {type:Object,default:{}},
  },


  data() {
    return {
      zoom: 18,
      center: latLng(30.2791476,57.0745852),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      withPopup: latLng(30.2791476,57.0745852),
      currentZoom: 11.5,
      showParagraph: false,
      mapOptions: {
        zoomSnap    : 0.5,
      },
      showMap   : true,
      icon: icon({
        iconUrl: "../img/icons/pin.png",
        iconSize: [42 ,42],
        iconAnchor: [16, 37]
      }),
    }
  },

  watch: {
    formData(data){
      this.center    =  latLng(data.lat,data.lng);
      this.withPopup =  latLng(data.lat,data.lng);
    }

  },

  created() {

  },

  mounted() {

  },

  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },

    centerUpdate(center) {
      this.currentCenter = center;
    },

    addMarker(data) {
        const currentPlaceLatlng    = data.latlng;
        const findCurrentParent     = data.originalEvent.target.parentNode.className;
        const lat                   = currentPlaceLatlng.lat;
        const lng                   = currentPlaceLatlng.lng;
        this.withPopup              =  latLng(lat,lng );

        const setMapData            = {
          lat : lat,
          lng : lng,
        }

        this.$emit('changeLocation',setMapData)
    },

  }


}
</script>
